module.exports = __webpack_public_path__ + "bbd614ba57fa3289bf1272006572eace.fbx";